import React, { useState } from 'react';
import styles from './Slide.module.scss';
import Text from '../../../../../atoms/text/Text';
import HtmlTag from '../../../../../molecule/htmlTag/HtmlTag';
import { useMediaQuery } from 'react-responsive';
import useIsRtl from '../../../../../../app/helpers/isRtl';
import Modal from '../../../../../hoc/modal/Modal';
import defaultProfile from './defaultProfile.png';
const quotationMark = '/icons/doubleQuoteRight.svg';
const closeSvg = '/icons/close.svg';

const TestimonialCard = ({ testimonial, language }) => {
  const isRtl = useIsRtl();
  const [showModal, setShowModal] = useState(false);
  const isTablet = useMediaQuery({ maxWidth: 1200 });
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const isArabic = language === 'ar';
  const fullName = isArabic ? testimonial.fullName_AR : testimonial.fullName_AR;
  const message = isArabic ? testimonial.messageAR : testimonial.messageAR;
  const testimonialHtml = isArabic
    ? testimonial.testimonial_AR
    : testimonial.testimonial_AR;
  const imageUrl = `${testimonial.url}${testimonial.testimonialImage}`;

  return (
    <div className={styles.card}>
      <div className={styles.quoteMark}>
        <img src={quotationMark} alt="quote" />
      </div>
      <HtmlTag
        className={styles.text}
        title={testimonialHtml}
        containerStyle={{ textAlign: 'justify' }}
        variant="text-bold-italic-16"
        maxLines={isMobile ? 7 : isTablet ? 6 : 7}
        style={{
          textAlign: isArabic ? 'right' : 'left',
          minHeight: isMobile ? '120px' : '120px',
        }}
        externalLineHeight={1.6}
      />
      {/* <div className={styles['readMore']}>
        <Text
          title="home.read_more"
          variant="text-bold-italic-16"
          className={`${styles['readMore-text']} ${isRtl ? styles['readMore-rtl'] : ''}`}
          onClick={() => setShowModal(true)}
          style={{ cursor: 'pointer' }}
        />
      </div> */}
      <div>
        <div className={styles['readMore']}>
          <Text
            title="home.read_more"
            variant="text-bold-italic-16"
            className={`${styles['readMore-text']} ${isRtl ? styles['readMore-rtl'] : ''}`}
            onClick={() => setShowModal(true)}
            style={{ cursor: 'pointer' }}
          />
        </div>{' '}
        <div
          className={styles.footer}
          style={{ direction: isRtl ? 'rtl' : '' }}
        >
          <div className={styles.avatarContainer}>
            <img
              src={imageUrl}
              alt={fullName}
              className={styles.avatar}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = defaultProfile;
              }}
            />
          </div>
          <div className={styles.studentInfo}>
            <Text
              title={fullName}
              variant="text-bold-italic-16"
              className={styles['infoText-title']}
              maxLines={1}
            />
            <Text
              title={message}
              variant="text-regular-14"
              className={styles.infoText}
              style={{ minHeight: '34px' }}
              maxLines={2}
            />
            <Text
              title={new Date(testimonial.testimonialDate).getFullYear()}
              variant="text-regular-14"
              className={styles.infoText}
            />
          </div>
        </div>
      </div>

      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        modalBodyClassname={styles.modalBody}
        dialogClassName={styles.dialogClassName}
      >
        <div
          className={`${styles.closeSvg} ${isRtl ? styles['close-rtl'] : ''}`}
        >
          <img src={closeSvg} alt="" onClick={() => setShowModal(false)} />
        </div>
        <div
          className={styles.modalContent}
          style={{ direction: isRtl ? 'rtl' : '' }}
        >
          <div className={styles['desc-container']}>
            <HtmlTag
              className={styles.text}
              title={testimonialHtml}
              containerStyle={{ textAlign: 'justify' }}
              variant="text-bold-italic-16"
              maxLines={999}
              style={{
                textAlign: isArabic ? 'right' : 'left',
                minHeight: isMobile ? '120px' : '120px',
              }}
              externalLineHeight={1.6}
            />
          </div>
          <div className={styles.footer}>
            <div className={styles.avatarContainer}>
              <img
                src={imageUrl}
                alt={fullName}
                className={styles.avatar}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultProfile;
                }}
              />
            </div>
            <div className={styles.studentInfo}>
              <Text
                title={fullName}
                variant="text-bold-italic-16"
                className={styles['infoText-title']}
              />
              <Text
                title={message}
                variant="text-regular-14"
                className={styles.infoText}
              />
              <Text
                title={new Date(testimonial.testimonialDate).getFullYear()}
                variant="text-regular-14"
                className={styles.infoText}
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const Slide = ({ testimonials, language }) => {
  return (
    <div className={styles['slide-one']}>
      <div className={styles.container}>
        {testimonials.map((testimonial) => (
          <TestimonialCard
            key={testimonial.testimonialId}
            testimonial={testimonial}
            language={language}
          />
        ))}
      </div>
    </div>
  );
};

export default Slide;
